import {CommentsCategory} from '@domain/comments'

import {PlannerDataScope} from './permissions'

export const checkPermissionCommentCategory =
  (requiredCommentCategory: CommentsCategory) => (dataScope: Partial<PlannerDataScope>) =>
    dataScope.commentCategory === requiredCommentCategory
